::ng-deep particle-fx-rate-currency-selector{display:flex}
/*# sourceMappingURL=fx-rate-currency-selector.component-N44YIM7K.css.map */
